import cn from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';

interface ISearchStringPanelProps {
  searchString: React.ReactNode;
  filters: React.ReactNode;
  isExpanded: boolean;
  isFiltersHidden: boolean;
  isAnimationForced?: boolean;
}

export const SearchStringPanel = ({
  searchString,
  filters,
  isExpanded,
  isFiltersHidden,
  isAnimationForced = false,
}: ISearchStringPanelProps) => (
  <div
    className={cn(
      styles['panel'],
      isExpanded && styles['panel_expanded'],
      isAnimationForced && styles['animation-forced'],
    )}
  >
    <div className={styles['search-string']}>{searchString}</div>
    <div className={cn(styles['filters'], isFiltersHidden && styles['filters_hidden'])}>
      <div className={styles['filters-viewport']}>
        <div className={styles['chips']}>{filters}</div>
      </div>
    </div>
  </div>
);
